export default "__VITE_ASSET__Db6UasJ6__"